type Props = {
	title: string;
	description: string;
	children: React.ReactNode;
};

export default function ApplicationSection({ title, description, children }: Props) {
	return (
		<section className="entertainer-form-section">
			<header>
				<h2>{title}</h2>
				<p>{description}</p>
			</header>
			<div className="entertainer-form-section-content">{children}</div>
		</section>
	);
}
